
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'

import Moment from 'moment'

import COVERAPP from '@/utils/COVERAPP'

@Options({
    data () {
        return {
            currentIndex: 0,
            years: [2016, 2017, 2018, 2019, 2020],
            timeId: null,
            isGeting: false
        }
    },
    computed: {
        ...mapState(['aid', 'userInfo', 'shareData', 'activityData'])
    },
    beforeUnmount () {
        clearInterval(this.timeId)
        this.currentIndex = 0
    },
    mounted () {
        this.$common.track(this.aid, 'load', '新闻2020年内的重大事件')
        this.activityData && this.$common.pageLoaded()
        this.shareData.title && this.$common.onshare(this.shareData, this.aid)
        this.timeId = setInterval(() => {
            this.changeData()
        }, 2000)
    },
    methods: {
        ...mapMutations(['SET_USERINFO', 'SET_YEARDATA', 'SET_DIALOGDATA']),
        changeData (): void {
            const items = document.querySelectorAll('.page-view .page-view-item') as NodeListOf<HTMLElement>
            if (this.currentIndex === items.length - 1) {
                clearInterval(this.timeId)
                const btn = document.querySelector('.page-view .btn') as HTMLElement
                btn.className = `${btn.className} show`
                return
            }
            this.currentIndex++
        },
        goData () {
            const _this = this
            this.$common.track(this.aid, 'click', '我的封面2020') 
            if (!COVERAPP.Attribute.isApp()) {
                this.SET_DIALOGDATA({
                    text: '参加该活动需在封面新闻APP中进行',
                    btns: [
                        {
                            text: '确定',
                            className : 'download-btn',
                            data: this.activityData.openApp
                        }
                    ]
                })
                return
            }
            if (!this.userInfo.token) {
                COVERAPP.Method.OpenLogin({
                    callback (ret: any) {
                        let userinfo = typeof ret == "string".toLowerCase() ? JSON.parse(ret) : ret
                        if (!_this.$common.isEmpty(userinfo.user_id)) {
                            if (userinfo.mobile) {
                                setTimeout(() => {
                                    _this.$common.getUser((res: any) => {
                                        _this.SET_USERINFO(res)
                                        _this.getData()
                                    }) 
                                }, 200)
                            } else {
                               _this.bindMobile()  
                            }       																													
                        }
                    }
                })
                return
            }
            if(!this.userInfo.mobile) {
                this.bindMobile()              
                return
            }
            this.getData()
        },
        bindMobile () {
            const _this = this
            COVERAPP.Method.bindMobile({
                callback(res: any) {
                    const result = typeof res != 'string' ? JSON.stringify(res) : res
                    if (result.indexOf('success') > -1) {
                        _this.$common.getUser((res: any) => {
                            _this.SET_USERINFO(res)
                            _this.getData()
                        })
                    }                    
                }
            })
        },
        getData () {
            if (this.isGeting) return
            this.isGeting = true
            this.$request('/year-report-2020', {
                aid: this.aid,
                userinfo: this.userInfo
            }, 'post').then((data: any) => {
                if (data && data.import_time) {
                    this.formatData(data)
                    this.$router.push({
                        path: '/data'
                    })
                } else {
                    this.noData()
                }
                this.isGeting = false
            }).catch((res: any) =>  {
                if (!res || !res.errno || (res.errno && res.errno != 1250 && res.errno != 1010 && res.errno != 1200)) {
                    this.$common.toast('加载失败，请重试！')
                } else if (res && res.errno == 1200) {
                    this.noData()
                }
                this.isGeting = false
            })
        },
        formatData (data: any) {
            let newData = JSON.parse(JSON.stringify(data))
            const times = ['import_time', 'first_news_view_date', 'first_discuss_date', 'first_share_date', 'first_live_view_date', 'first_dynamic_create_date', 'last_arrive_date', 'use_time_early', 'use_time_lately']
            for (let time of times) {
                newData[time] && (newData[time] = Moment(data[time]).utc().format('YYYY-M-D-H-m').split('-'))
            }
            if (newData.channel_label) {
                newData.channel_label = newData.channel_label.split(',')
            }
            this.SET_YEARDATA(newData)
            sessionStorage.setItem('YEARDATA', JSON.stringify(newData))
        },
        noData () {
            this.SET_DIALOGDATA({
                text: '错过了封面2020的精彩<br>但仍有一份惊喜礼物送给你<br>欢迎你加入封面，2021一起加油呀',
                btns: [
                    {
                        text: '新人惊喜礼',
                        className: 'getHb-btn'
                    }
                ]
            })
        }
    }
})
export default class FootPrint extends Vue {}
